var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTimeLight = function SvgIconTimeLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_time_light_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_time_light_svg__b)",
    fill: "#656A71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.05c-4.44 0-8.05-3.61-8.05-8.05 0-4.44 3.61-8.05 8.05-8.05 4.44 0 8.05 3.61 8.05 8.05 0 4.44-3.61 8.05-8.05 8.05Zm0-15c-3.83 0-6.95 3.12-6.95 6.95s3.12 6.95 6.95 6.95 6.95-3.12 6.95-6.95S15.83 5.05 12 5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.26 15.013-2.47-2.475a1.146 1.146 0 0 1-.335-.815V7.488h1.1v4.235l2.485 2.51-.78.775v.005Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_time_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_time_light_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconTimeLight;